export type DeviceType = 'Mobile' | 'Tablet' | 'Desktop';

export const getDeviceType = (): DeviceType => {
  const deviceWidth = window.screen.width;

  if (deviceWidth < 768) {
    return 'Mobile';
  }

  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  if (deviceWidth >= 768 && deviceWidth < 1024) {
    return hasTouchScreen ? 'Tablet' : 'Desktop';
  }

  if (deviceWidth >= 1024 && deviceWidth < 1366 && hasTouchScreen) {
    return 'Tablet';
  }

  return 'Desktop';
};
